import WaterMarkModal from './modal.vue';
import { createModal } from '@lingtu/components';
import { useUserStoreWithOut } from '/@/store/modules/user';
import { isNil } from 'lodash-es';
import { apis } from '/@/apis';
import to from 'await-to-js';

/* 下载水印确认
 * @returns true: 带水印
 * @returns false: 不带水印
 * @returns null: 中断下载
 * @return Promise<boolean | null>
 */
export async function watermarkConfirm(): Promise<boolean | null> {
  const { userInfo, setUserInfo } = useUserStoreWithOut();
  if (!isNil(userInfo?.watermark)) {
    return userInfo?.watermark;
  }
  return await new Promise((resolve) => {
    createModal({
      params: {
        onOk: async (watermark: boolean, remember: boolean) => {
          if (remember) {
            // 调用接口保存用户设置
            to(apis.user.setWatermark({ watermark }));
            setUserInfo({
              watermark,
            });
          }
          resolve(watermark);
        },
        onCancel: () => {
          resolve(null);
        },
      },
      component: WaterMarkModal,
    });
  });
}
